import React from "react";

export default function DropDownIcon() {
  return (
    <div style={{ marginLeft: "10px" }}>
      {" "}
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.96 0.5H3.04C1.6372 0.5 0.5 1.6372 0.5 3.04V12.96C0.5 14.3628 1.6372 15.5 3.04 15.5H12.96C14.3628 15.5 15.5 14.3628 15.5 12.96V3.04C15.5 1.6372 14.3628 0.5 12.96 0.5ZM14.1 12.96C14.1 13.5896 13.5896 14.1 12.96 14.1H3.03999C2.41039 14.1 1.89999 13.5896 1.89999 12.96V3.04C1.89999 2.41039 2.41039 1.9 3.03999 1.9H12.96C13.5896 1.9 14.1 2.41039 14.1 3.04V12.96ZM7.4962 10.5145C7.63151 10.6416 7.80958 10.713 7.99501 10.7145C8.18044 10.713 8.35852 10.6416 8.49383 10.5145L11.786 7.2245C11.9226 7.09425 12 6.91351 12 6.7245C12 6.53549 11.9226 6.35475 11.786 6.2245C11.6561 6.08754 11.4758 6.01 11.2872 6.01C11.0986 6.01 10.9183 6.08754 10.7884 6.2245L7.99501 9.0145L5.21162 6.2145C5.08168 6.07754 4.90137 6 4.71281 6C4.52424 6 4.34394 6.07754 4.21399 6.2145C4.07735 6.34475 4 6.52549 4 6.7145C4 6.90351 4.07735 7.08425 4.21399 7.2145L7.4962 10.5145Z"
          fill="#12344D"
        />
      </svg>
    </div>
  );
}
